import styled from "styled-components";

const MenuDivider = styled.div`
  border-bottom: 1px solid #d1d2d4;
  height: 1px;
  margin: 6px 10px;
`;

export default MenuDivider;
